// extracted by css-extract-rspack-plugin
export default {"small_button_override":"nSA6Z","smallButtonOverride":"nSA6Z","#":"Ynzk3"};